export default __webpack_public_path__ + "static/media/614.6bfdc919.png";